export default "__VITE_PUBLIC_ASSET__9c8e05e5__"